// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { OutcomeFormCategoryInformationFragmentDoc } from '../../__generated-gql-types__/OutcomeForm.generated';
export type OutcomeModalCategoryInformationFragment = {
  __typename?: 'CategoryInformation';
  category: {
    __typename?: 'Category';
    id: string;
    goal: Types.GoalName;
    name: string;
    subCategoryTitle?: string | null;
    subCategoryList?: Array<{
      __typename?: 'SubCategory';
      id: string;
      name: string;
    }> | null;
  };
};

export const OutcomeModalCategoryInformationFragmentDoc = gql`
  fragment OutcomeModal_CategoryInformation on CategoryInformation {
    ...OutcomeForm_CategoryInformation
  }
  ${OutcomeFormCategoryInformationFragmentDoc}
`;
